export default "__VITE_ASSET__55dba649__"